import React from 'react';
import { motion } from 'framer-motion';
import { whyChooseUs } from '../data/mockData';
import * as Icons from 'lucide-react';

const WhyChooseUsSection = () => {
  return (
    <section data-testid="why-choose-section" className="py-28 relative">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#3B82F6]/10 border border-[#3B82F6]/20 mb-5">
            <span className="text-xs font-semibold text-[#3B82F6] uppercase tracking-wider">Why Choose Us</span>
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-white mb-5">
            Why Brands <span className="text-gradient">Trust Us</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {whyChooseUs.map((usp, index) => {
            const IconComponent = Icons[usp.icon];
            return (
              <motion.div key={usp.id}
                className="glass-card rounded-2xl p-7 text-center group hover:border-[#3B82F6]/30 transition-all"
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }}>
                <div className="w-14 h-14 rounded-2xl bg-[#3B82F6]/10 flex items-center justify-center mx-auto mb-5 group-hover:bg-[#3B82F6]/20 transition-colors icon-hover">
                  {IconComponent && <IconComponent className="w-7 h-7 text-[#3B82F6]" />}
                </div>
                <h3 className="font-heading text-lg font-semibold text-white mb-3">{usp.title}</h3>
                <p className="text-sm text-[#A1A1AA] leading-relaxed">{usp.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
